import { render, staticRenderFns } from "./SurveyManagementEditEmailQuestion.vue?vue&type=template&id=d93d088c&scoped=true&"
import script from "./SurveyManagementEditEmailQuestion.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementEditEmailQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementEditEmailQuestion.vue?vue&type=style&index=0&id=d93d088c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93d088c",
  null
  
)

/* custom blocks */
import block0 from "./SurveyManagementEditEmailQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d93d088c')) {
      api.createRecord('d93d088c', component.options)
    } else {
      api.reload('d93d088c', component.options)
    }
    module.hot.accept("./SurveyManagementEditEmailQuestion.vue?vue&type=template&id=d93d088c&scoped=true&", function () {
      api.rerender('d93d088c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/questions/SurveyManagementEditEmailQuestion.vue"
export default component.exports